export default __webpack_public_path__ + "static/media/item_7.17d80b53.png";